import { render, staticRenderFns } from "./addPlatformJob.vue?vue&type=template&id=744299ff&scoped=true"
import script from "./addPlatformJob.vue?vue&type=script&lang=js"
export * from "./addPlatformJob.vue?vue&type=script&lang=js"
import style0 from "./addPlatformJob.vue?vue&type=style&index=0&id=744299ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744299ff",
  null
  
)

export default component.exports